import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchComplaints,
    getComplaints,
} from '../../app/reducers/Complaints/complaintSlice';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import PaginationClassic from '../../components/infrastructure/pagination/PaginationClassic';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import CloseComplaintModal from './CloseComplaintModal';
import AssignTechnicianModal from './AssignTechnicianModal';
import SetButtons from '../../components/infrastructure/SetButtons';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ShowDropdown from '../../components/infrastructure/ShowDropdown';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import { useFormik } from 'formik';
import moment from 'moment-timezone';
import QueryString from 'qs';
import { authAxiosInstance } from '../../utils/axiosConfig';
import { buildRange, exportCsv, ASSIGN_TECHNICIAN_ACCESS_ROLE } from '../../utils/Utils';
import ObservationModal from './ObservationModal';
import CancelModal from './CancelModal';
import { format } from 'prettier';
import { ClipLoader } from 'react-spinners';
import UnderlineTabs from '../../components/infrastructure/Tabs/UnderlineTabs';
import EditComoplaintResolutionModal from './EditComoplaintResolutionModal';
import { getAuth } from '../../app/reducers/Auth/authSlice';
import PendingModal from './PendingModal';
import TimeInModal from './TimeInModal';
import ChangeAssignedTechnicianModal from './ChangeAssignedTechnicianModal';
import { fetchEmployees } from '../../app/reducers/Users/EmployeeSlice';
import { toast } from 'react-toastify';
import DocumentPreview from '../Products/DocumentPreview';
import VideoPreview from '../Products/VideoPreview';

const ViewComplaint = () => {
    //state
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isCloseComplaintBtnOpen, setIsCloseComplaintBtnOpen] =
        useState(false);
    const [closeComplaintData, setCloseComplaintData] = useState({});
    const [isAssignTechnicianBtnOpen, setIsAssignTechnicianBtnOpen] =
        useState(false);
    const [assignTechnicianData, setAssignTechnicianData] = useState({});
    const [openObservationModal, setOpenObservationModal] = useState(false);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [previewImg, setPreviewImg] = useState([]);
    const [previewVideoModalOpen, setPreviewVideoModalOpen] = useState(false);
    const [previewVideos, setPreviewVideos] = useState([]);
    const [editComoplaintResolutionModalOpen, setEditComoplaintResolutionModalOpen] = useState(false);
    const [selectedComplaint, setSelectedComplaint] = useState({});
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [openPendingModal, setOpenPendingModal] = useState(false);
    const [pendingComplaintData, setPendingComplaintData] = useState({});
    const [openTimeInModal, setOpenTimeInModal] = useState(false);
    const [timeInComplaintData, setTimeInComplaintData] = useState({});
    const [changeAssignedComplaintId, setChangeAssignedComplaintId] = useState(null);
    const [isChangeAssignedModalOpen, setIsChangeAssignedModalOpen] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [companyDispatchLocation, setCompanyDispatchLocation] = useState(null)
    //redux
    const { complaint, loading } = useSelector(getComplaints);
    const { user } = useSelector(getAuth);
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const isEngineer = user?.role === 'engineer';
    const { status } = useParams();
    useEffect(() => {
        if (isEngineer && status === 'open') {
            navigate('/complaint/view-complaint/InProgress', {
                replace: true,
            });
        }
    }, [isEngineer, status, navigate]);
    const selectedTab = status || (isEngineer ? 'InProgress' : 'open');

    const allTabs = [
        { label: 'open', value: 'open' },
        { label: 'Assigned', value: 'InProgress' },
        { label: 'TimeIn', value: 'timeIn' },
        { label: 'Pending', value: 'pending' },
        { label: 'observation', value: 'observation' },
        { label: 'closed', value: 'closed' },
        { label: 'canceled', value: 'canceled' },
    ];
    const tabHeaders = isEngineer
        ? allTabs.filter((t) => t.value !== 'open')
        : allTabs;

    useEffect(() => {
        dispatch(
            fetchComplaints({
                populate: true,
                page,
                status: selectedTab,
            })
        );
    }, [page, selectedTab, dispatch]);

    const formik = useFormik({
        initialValues: {
            from: moment().subtract(1, 'months').startOf('day').valueOf(),
            to: moment().endOf('day').valueOf(),
        },
        onSubmit: async (values) => {
            try {
                setIsLoading(true)
                const string = QueryString.stringify({
                    populate: true,
                    page: 1,
                    limit: 5000,
                    createdAt: buildRange(formik.values.from, formik.values.to)

                });
                const response = await authAxiosInstance.get(
                    `/complaint?${string}`
                );
                if (response?.data?.data?.docs?.length > 0) {
                    let updatedData = response?.data?.data?.docs?.map((d) => {
                        return {
                            complaintNumber: d.complaintNumber ?? '',
                            customer: d.customer?.name ?? '',
                            company: d.customer?.companyData?.name ?? '',
                            product: d.product?.name ?? '',
                            description: d.description ?? '',
                            status: d.status ?? '',
                            assignedTo: d.assignedTo ?? '',
                            machineNo: d.machineNo ?? '',
                            team: d.team ?? '',
                            machineWarranty: d.machineWarranty ?? '',
                            resolution: d.resolution ?? '',
                            pendingNotes: d.pendingNotes ?? '',
                            observationNotes: d.observationNotes ?? '',
                            cancellationNotes: d.cancellationNotes ?? '',
                            resolutionPhotos: d.resolutionPhotos?.join('; ') ?? '',
                            resolutionVideos: d.resolutionVideos?.join('; ') ?? '',
                            createdAt: d.createdAt
                                ? moment(d.createdAt).format('DD/MM/YYYY HH:mm')
                                : '',
                            date: d.date
                                ? moment(d.date).format('DD/MM/YYYY HH:mm')
                                : '',
                            timeInDate: d.timeInDate
                                ? moment(d.timeInDate).format('DD/MM/YYYY HH:mm')
                                : '',
                            inProgressDate: d.inProgressDate
                                ? moment(d.inProgressDate).format('DD/MM/YYYY HH:mm')
                                : '',
                            pendingDate: d.pendingDate
                                ? moment(d.pendingDate).format('DD/MM/YYYY HH:mm')
                                : '',
                            observationDate: d.observationDate
                                ? moment(d.observationDate).format('DD/MM/YYYY HH:mm')
                                : '',
                            closedDate: d.closedDate
                                ? moment(d.closedDate).format('DD/MM/YYYY HH:mm')
                                : '',
                            cancelDate: d.cancelDate
                                ? moment(d.cancelDate).format('DD/MM/YYYY HH:mm')
                                : '',
                        };
                    });
                    exportCsv(updatedData);
                } else {
                    alert('No Data Found');
                }
            } catch (error) {
                console.log('Error', error)
            } finally {
                setIsLoading(false)
            }
        },
    });
    const commonColumns = [
        {
            Header: 'Date',
            Cell: ({ row }) => {
                const dates = [];
                if (row?.original?.date) {
                    dates.push(`Op :- ${moment(row?.original?.date).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.inProgressDate) {
                    dates.push(`Ip :- ${moment(row?.original?.inProgressDate).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.timeInDate) {
                    dates.push(`TimeIn :- ${moment(row?.original?.timeInDate).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.pendingDate) {
                    dates.push(`Pending :- ${moment(row?.original?.pendingDate).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.observationDate) {
                    dates.push(`Obs :- ${moment(row?.original?.observationDate).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.closedDate) {
                    dates.push(`Cld :- ${moment(row?.original?.closedDate).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.cancelDate) {
                    dates.push(`Cncl :- ${moment(row?.original?.cancelDate).format('DD/MM/YYYY HH:mm')}`);
                }
                return (
                    <div className="flex flex-col gap-x-3 gap-y-1 w-[180px]">
                        {dates.map((d, i) => (
                            <p key={i} className="text-xs whitespace-nowrap">{d}</p>
                        ))}
                    </div>
                );
            },
        },
        {
            Header: 'Company',
            Cell: ({ row }) => {
                const companyName = row.original?.customer?.companyData?.name;
                const customerName = row.original?.customer?.name;
                const complaintNumber = row.original?.complaintNumber;

                const executiveIds =
                    row.original?.customer?.companyData?.executive || [];

                const location =
                    row.original?.customer?.dispatchLocationData?.name;

                const executiveNames = employees
                    ?.filter((emp) => executiveIds?.includes(emp._id))
                    ?.map(
                        (emp) =>
                            `${emp.firstName || ''} ${emp.lastName || ''}`.trim()
                    )
                    ?.filter(Boolean)
                    ?.join(', ');

                return (
                    <div className="w-[250px]">
                        <div className="font-semibold text-slate-800">
                            {companyName || '--'}
                        </div>

                        <div className="text-xs text-slate-500 mb-2">
                            {customerName || '--'}
                        </div>

                        <div className="space-y-2 text-xs">
                            <div className="flex items-center gap-2">
                                <span className="font-medium text-slate-500 w-[75px]">
                                    Complaint No.
                                </span>
                                <span className="px-2 py-0.5 rounded bg-blue-50 text-blue-700">
                                    {complaintNumber}
                                </span>
                            </div>

                            <div className="flex items-center gap-2 mb-2">
                                <span className="font-medium text-slate-500 w-[75px]">
                                    Executive
                                </span>
                                <span className="px-2 py-0.5 rounded bg-green-50 text-green-700 text-wrap">
                                    {executiveNames || '--'}
                                </span>
                            </div>

                            <div className="flex items-center gap-2">
                                <span className="font-medium text-slate-500 w-[75px]">
                                    Location
                                </span>
                                <span className="px-2 py-0.5 rounded bg-purple-50 text-purple-700">
                                    {location || '--'}
                                </span>
                            </div>
                        </div>
                    </div>
                );
            },
        },
        {
            Header: 'Machine',
            accessor: 'product.name',
            Cell: (({ row }) => {
                return (
                    <div className="w-[300px]">
                        {/* Product Name */}
                        <p className="font-medium text-wrap">
                            {row?.original?.product?.name}
                        </p>
                        <div className="border-t border-gray-300 my-2"></div>

                        {/* Description */}
                        {row?.original?.description && (
                            <div className="mt-2">
                                <p className="font-semibold text-sm">Description</p>
                                <p className="italic text-wrap text-sm text-gray-600">
                                    {row?.original?.description}
                                </p>
                            </div>
                        )}
                    </div>
                );
            })
        },
        // {
        //     Header: 'Pending Notes',
        //     Cell: ({ row }) => {
        //         console.log("row123456", row)
        //         return (
        //             <div className="w-[300px]">
        //                 <p className="text-wrap ">
        //                     {row?.original?.pendingNotes}
        //                 </p>
        //             </div>
        //         );
        //     },
        // },

    ]
    const openCol = [
        {
            Header: 'SRNO',
            Cell: (prop) => {
                const { row } = prop;

                const userName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
                const assignedTo = `${row?.original?.assignedTo || ''}`.trim();

                const isAssigned =
                    user?._id === row?.original?.assignedId?._id ||
                    userName === assignedTo ||
                    ASSIGN_TECHNICIAN_ACCESS_ROLE.includes(user.role);

                return (
                    <div className="min-w-[140px] flex flex-col gap-3">
                        <div className="border-b pb-2">
                            <p className="font-semibold ">
                                {row.index + complaint?.pagingCounter}
                            </p>
                        </div>

                        {isAssigned && (
                            <div
                                className="flex flex-col gap-2"
                                onClick={(e) => e.stopPropagation()}
                            >
                                {['sup_admin', 'admin', 'local_admin'].includes(user?.role) && (
                                    <PrimaryButton
                                        className="text-xs py-1"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenCancelModal(true);
                                            setCloseComplaintData(row?.original);
                                        }}
                                        type="button"
                                    >
                                        Cancel
                                    </PrimaryButton>
                                )}

                                {ASSIGN_TECHNICIAN_ACCESS_ROLE.includes(user?.role) && (
                                    <PrimaryButton
                                        className="text-xs py-1"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setIsAssignTechnicianBtnOpen(true);
                                            setAssignTechnicianData(row?.original);
                                            setCompanyDispatchLocation(
                                                row?.original?.customer?.companyData?.dispatchLocation
                                            );
                                        }}
                                        type="button"
                                    >
                                        Assign Tech
                                    </PrimaryButton>
                                )}
                            </div>
                        )}
                    </div>
                );
            },
        },
        ...commonColumns,
        {
            Header: 'Photo / Video',
            Cell: ({ row }) => {
                const photos = row.original?.photos || [];
                const videos = row.original?.videos || [];

                return (
                    <div className="w-[150px] flex flex-col gap-3">
                        {/* Photos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Photos
                            </p>

                            {photos.length > 0 ? (
                                <>
                                    <img
                                        src={`${process.env.REACT_APP_S3_URL}${photos[0]}`}
                                        alt="Preview"
                                        className="h-20 w-full rounded object-cover border"
                                    />

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewImg(photos);
                                            setPreviewModalOpen(true);
                                        }}
                                    >
                                        View More ({photos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Photos
                                </p>
                            )}
                        </div>

                        {/* Videos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Videos
                            </p>

                            {videos.length > 0 ? (
                                <>
                                    <div className="text-sm text-slate-700 truncate">
                                        🎥 Video 1
                                    </div>

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewVideos(videos);
                                            setPreviewVideoModalOpen(true);
                                        }}
                                    >
                                        View More ({videos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Videos
                                </p>
                            )}
                        </div>
                    </div>
                );
            },
        },

    ];
    const InProgressCol = [
        {
            Header: 'SRNO',
            Cell: (prop) => {
                const { row } = prop;

                const userName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
                const assignedTo = `${row?.original?.assignedTo || ''}`.trim();

                const isAssigned =
                    user?._id === row?.original?.assignedId?._id ||
                    userName === assignedTo ||
                    ASSIGN_TECHNICIAN_ACCESS_ROLE.includes(user.role);

                return (
                    <div className="min-w-[160px] flex flex-col gap-3">
                        <div className="border-b pb-2">
                            <p className="font-semibold ">
                                {row.index + complaint?.pagingCounter}
                            </p>
                        </div>

                        <div className="text-sm">
                            <span className="text-slate-500">Technician : </span>{' '}
                            <span className="font-medium text-slate-700 text-wrap">
                                {row?.original?.assignedTo || '--'}
                            </span>
                        </div>

                        <div
                            className="flex flex-col gap-2"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {isAssigned && (
                                <PrimaryButton
                                    className="text-xs py-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenTimeInModal(true);
                                        setTimeInComplaintData(row?.original);
                                    }}
                                    type="button"
                                >
                                    TimeIn
                                </PrimaryButton>
                            )}

                            {ASSIGN_TECHNICIAN_ACCESS_ROLE.includes(user.role) && (
                                <PrimaryButton
                                    className="text-xs py-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsChangeAssignedModalOpen(true);
                                        setChangeAssignedComplaintId(row?.original?._id);
                                        setCompanyDispatchLocation(
                                            row?.original?.customer?.companyData?.dispatchLocation
                                        );
                                    }}
                                    type="button"
                                >
                                    Change Technician
                                </PrimaryButton>
                            )}

                            {['sup_admin', 'admin', 'local_admin'].includes(user?.role) && (
                                <PrimaryButton
                                    className="text-xs py-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenCancelModal(true);
                                        setCloseComplaintData(row?.original);
                                    }}
                                    type="button"
                                >
                                    Cancel Complaint
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                );
            },
        },
        ...commonColumns,
        {
            Header: 'Photo / Video',
            Cell: ({ row }) => {
                const photos = row.original?.photos || [];
                const videos = row.original?.videos || [];

                return (
                    <div className="w-[150px] flex flex-col gap-3">
                        {/* Photos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Photos
                            </p>

                            {photos.length > 0 ? (
                                <>
                                    <img
                                        src={`${process.env.REACT_APP_S3_URL}${photos[0]}`}
                                        alt="Preview"
                                        className="h-20 w-full rounded object-cover border"
                                    />

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewImg(photos);
                                            setPreviewModalOpen(true);
                                        }}
                                    >
                                        View More ({photos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Photos
                                </p>
                            )}
                        </div>

                        {/* Videos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Videos
                            </p>

                            {videos.length > 0 ? (
                                <>
                                    <div className="text-sm text-slate-700 truncate">
                                        🎥 Video 1
                                    </div>

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewVideos(videos);
                                            setPreviewVideoModalOpen(true);
                                        }}
                                    >
                                        View More ({videos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Videos
                                </p>
                            )}
                        </div>
                    </div>
                );
            },
        },
    ];
    const observationCol = [
        {
            Header: 'SRNO',
            Cell: (prop) => {
                const { row } = prop;

                const userName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
                const assignedTo = `${row?.original?.assignedTo || ''}`.trim();

                const isAssigned =
                    user?._id === row?.original?.assignedId?._id ||
                    userName === assignedTo ||
                    ASSIGN_TECHNICIAN_ACCESS_ROLE.includes(user.role);

                return (
                    <div className="min-w-[160px] flex flex-col gap-3">
                        <div className="border-b pb-2">
                            <p className="font-semibold ">
                                {row.index + complaint?.pagingCounter}
                            </p>
                        </div>
                        <div className="text-sm">
                            <span className="text-slate-500">Technician : </span>{' '}
                            <span className="font-medium text-slate-700 text-wrap">
                                {row?.original?.assignedTo || '--'}
                            </span>
                        </div>
                        <div
                            className="flex flex-col gap-2"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {isAssigned && (
                                <PrimaryButton
                                    className="text-xs py-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsCloseComplaintBtnOpen(true);
                                        setCloseComplaintData(row?.original);
                                        setCompanyDispatchLocation(
                                            row?.original?.customer?.companyData?.dispatchLocation
                                        );
                                    }}
                                    type="button"
                                >
                                    Close
                                </PrimaryButton>
                            )}

                            {ASSIGN_TECHNICIAN_ACCESS_ROLE.includes(user.role) && (
                                <PrimaryButton
                                    className="text-xs py-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsChangeAssignedModalOpen(true);
                                        setChangeAssignedComplaintId(row?.original?._id);
                                        setCompanyDispatchLocation(
                                            row?.original?.customer?.companyData?.dispatchLocation
                                        );
                                    }}
                                    type="button"
                                >
                                    Change Technician
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                );
            },
        },
        ...commonColumns,
        {
            Header: 'Observation',
            Cell: ({ row }) => {
                return (
                    <div className="w-[300px] ">
                        <p className='text-wrap'>{row?.original?.observationNotes}</p>
                    </div>
                );
            },
        },
        {
            Header: 'Ob Date',
            Cell: ({ row }) => {
                return (
                    <div>
                        {row.original.observationDate
                            ? moment
                                .tz(
                                    row?.original?.observationDate,
                                    'Asia/Kolkata'
                                )
                                .format('DD-MM-YYYY')
                            : ''}
                    </div>
                );
            },
        },
        {
            Header: 'Photo / Video',
            Cell: ({ row }) => {
                const photos = row.original?.photos || [];
                const videos = row.original?.videos || [];

                return (
                    <div className="w-[150px] flex flex-col gap-3">
                        {/* Photos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Photos
                            </p>

                            {photos.length > 0 ? (
                                <>
                                    <img
                                        src={`${process.env.REACT_APP_S3_URL}${photos[0]}`}
                                        alt="Preview"
                                        className="h-20 w-full rounded object-cover border"
                                    />

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewImg(photos);
                                            setPreviewModalOpen(true);
                                        }}
                                    >
                                        View More ({photos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Photos
                                </p>
                            )}
                        </div>

                        {/* Videos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Videos
                            </p>

                            {videos.length > 0 ? (
                                <>
                                    <div className="text-sm text-slate-700 truncate">
                                        🎥 Video 1
                                    </div>

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewVideos(videos);
                                            setPreviewVideoModalOpen(true);
                                        }}
                                    >
                                        View More ({videos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Videos
                                </p>
                            )}
                        </div>
                    </div>
                );
            },
        },
    ];
    const closedCol = [
        {
            Header: 'SRNO',
            Cell: (prop) => {
                const { row } = prop;

                const userName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
                const assignedTo = `${row?.original?.assignedTo || ''}`.trim();

                const isAssigned =
                    user?._id === row?.original?.assignedId?._id ||
                    userName === assignedTo ||
                    ASSIGN_TECHNICIAN_ACCESS_ROLE.includes(user.role);

                return (
                    <div className="min-w-[140px] flex flex-col gap-3">
                        <div className="border-b border-slate-200 pb-2">
                            <p className="font-semibold text-slate-800">
                                {row.index + complaint?.pagingCounter}
                            </p>
                        </div>

                        <div className="text-sm">
                            <span className="text-slate-500">Technician : </span>{' '}
                            <span className="font-medium text-slate-700 text-wrap">
                                {row?.original?.assignedTo || '--'}
                            </span>
                        </div>

                        {isAssigned && (
                            <div
                                className="flex flex-col gap-2"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <PrimaryButton
                                    className="text-xs py-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setEditComoplaintResolutionModalOpen(true);
                                        setSelectedComplaint(row?.original);
                                    }}
                                >
                                    Edit Resolution
                                </PrimaryButton>
                            </div>
                        )}
                    </div>
                );
            },
        },
        ...commonColumns,
        {
            Header: 'Observation',
            Cell: ({ row }) => {
                return (
                    <div className="w-[200px] ">
                        <p className='text-wrap'>{row?.original?.observationNotes}</p>
                    </div>
                );
            },
        },
        {
            Header: 'Ob Date',
            Cell: ({ row }) => {
                return (
                    <div className='w-[120px]'>
                        {row.original.observationDate
                            ? moment
                                .tz(
                                    row?.original?.observationDate,
                                    'Asia/Kolkata'
                                )
                                .format('DD-MM-YYYY')
                            : ''}
                    </div>
                );
            },
        },
        {
            Header: 'Resolution',
            Cell: ({ row }) => {
                return (
                    <div className="w-[350px] ">
                        <p className='text-wrap'>{row?.original?.resolution}</p>
                    </div>
                );
            },
        },
        {
            Header: 'Photo / Video',
            Cell: ({ row }) => {
                const photos = row.original?.photos || [];
                const videos = row.original?.videos || [];

                return (
                    <div className="w-[150px] flex flex-col gap-3">
                        {/* Photos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Photos
                            </p>

                            {photos.length > 0 ? (
                                <>
                                    <img
                                        src={`${process.env.REACT_APP_S3_URL}${photos[0]}`}
                                        alt="Preview"
                                        className="h-20 w-full rounded object-cover border"
                                    />

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewImg(photos);
                                            setPreviewModalOpen(true);
                                        }}
                                    >
                                        View More ({photos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Photos
                                </p>
                            )}
                        </div>

                        {/* Videos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Videos
                            </p>

                            {videos.length > 0 ? (
                                <>
                                    <div className="text-sm text-slate-700 truncate">
                                        🎥 Video 1
                                    </div>

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewVideos(videos);
                                            setPreviewVideoModalOpen(true);
                                        }}
                                    >
                                        View More ({videos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Videos
                                </p>
                            )}
                        </div>
                    </div>
                );
            },
        },
    ];
    const pendingCol = [
        {
            Header: 'SRNO',
            Cell: (prop) => {
                const { row } = prop;

                return (
                    <div className="min-w-[160px] flex flex-col gap-3">
                        <div className="border-b border-slate-200 pb-2">
                            <p className="font-semibold text-slate-800">
                                {row.index + complaint?.pagingCounter}
                            </p>
                        </div>

                        <div className="text-sm">
                            <span className="text-slate-500">Technician : </span>{' '}
                            <span className="font-medium text-slate-700 text-wrap">
                                {row?.original?.assignedTo || '--'}
                            </span>
                        </div>

                        <div
                            className="flex flex-col gap-2"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <PrimaryButton
                                className="text-xs py-1"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsCloseComplaintBtnOpen(true);
                                    setCloseComplaintData(row?.original);
                                    setCompanyDispatchLocation(
                                        row?.original?.customer?.companyData?.dispatchLocation
                                    );
                                }}
                                type="button"
                            >
                                Close
                            </PrimaryButton>

                            <PrimaryButton
                                className="text-xs py-1"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setOpenObservationModal(true);
                                    setCloseComplaintData(row?.original);
                                }}
                                type="button"
                            >
                                Observation
                            </PrimaryButton>

                            {ASSIGN_TECHNICIAN_ACCESS_ROLE.includes(user.role) && (
                                <PrimaryButton
                                    className="text-xs py-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsChangeAssignedModalOpen(true);
                                        setChangeAssignedComplaintId(row?.original?._id);
                                        setCompanyDispatchLocation(
                                            row?.original?.customer?.companyData?.dispatchLocation
                                        );
                                    }}
                                    type="button"
                                >
                                    Change Technician
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                );
            },
        },
        ...commonColumns,
        {
            Header: 'Pending Notes',
            Cell: ({ row }) => {
                console.log("row123456", row)
                return (
                    <div className="w-[300px]">
                        <p className="text-wrap ">
                            {row?.original?.pendingNotes}
                        </p>
                    </div>
                );
            },
        },
        {
            Header: 'Photo / Video',
            Cell: ({ row }) => {
                const photos = row.original?.photos || [];
                const videos = row.original?.videos || [];

                return (
                    <div className="w-[150px] flex flex-col gap-3">
                        {/* Photos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Photos
                            </p>

                            {photos.length > 0 ? (
                                <>
                                    <img
                                        src={`${process.env.REACT_APP_S3_URL}${photos[0]}`}
                                        alt="Preview"
                                        className="h-20 w-full rounded object-cover border"
                                    />

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewImg(photos);
                                            setPreviewModalOpen(true);
                                        }}
                                    >
                                        View More ({photos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Photos
                                </p>
                            )}
                        </div>

                        {/* Videos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Videos
                            </p>

                            {videos.length > 0 ? (
                                <>
                                    <div className="text-sm text-slate-700 truncate">
                                        🎥 Video 1
                                    </div>

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewVideos(videos);
                                            setPreviewVideoModalOpen(true);
                                        }}
                                    >
                                        View More ({videos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Videos
                                </p>
                            )}
                        </div>
                    </div>
                );
            },
        },
    ];
    const timeInCol = [
        {
            Header: 'SRNO',
            Cell: (prop) => {
                const { row } = prop;

                const userName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
                const assignedTo = `${row?.original?.assignedTo || ''}`.trim();

                const isAssigned =
                    user?._id === row?.original?.assignedId?._id ||
                    userName === assignedTo ||
                    ASSIGN_TECHNICIAN_ACCESS_ROLE.includes(user.role);

                return (
                    <div className="min-w-[160px] flex flex-col gap-3">
                        <div className="border-b border-slate-200 pb-2">
                            <p className="font-semibold text-slate-800">
                                {row.index + complaint?.pagingCounter}
                            </p>
                        </div>

                        <div className="text-sm">
                            <span className="text-slate-500">Technician : </span>{' '}
                            <span className="font-medium text-slate-700 text-wrap">
                                {row?.original?.assignedTo || '--'}
                            </span>
                        </div>

                        {isAssigned && (
                            <div
                                className="flex flex-col gap-2"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <PrimaryButton
                                    className="text-xs py-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenObservationModal(true);
                                        setCloseComplaintData(row?.original);
                                    }}
                                    type="button"
                                >
                                    Observation
                                </PrimaryButton>

                                <PrimaryButton
                                    className="text-xs py-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenPendingModal(true);
                                        setPendingComplaintData(row?.original);
                                    }}
                                    type="button"
                                >
                                    Pending
                                </PrimaryButton>

                                {ASSIGN_TECHNICIAN_ACCESS_ROLE.includes(user.role) && (
                                    <PrimaryButton
                                        className="text-xs py-1"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setIsChangeAssignedModalOpen(true);
                                            setChangeAssignedComplaintId(row?.original?._id);
                                            setCompanyDispatchLocation(
                                                row?.original?.customer?.companyData?.dispatchLocation
                                            );
                                        }}
                                        type="button"
                                    >
                                        Change Technician
                                    </PrimaryButton>
                                )}

                                <PrimaryButton
                                    className="text-xs py-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsCloseComplaintBtnOpen(true);
                                        setCloseComplaintData(row?.original);
                                        setCompanyDispatchLocation(
                                            row?.original?.customer?.companyData?.dispatchLocation
                                        );
                                    }}
                                    type="button"
                                >
                                    Close
                                </PrimaryButton>
                            </div>
                        )}
                    </div>
                );
            },
        },
        ...commonColumns,
        {
            Header: 'Photo / Video',
            Cell: ({ row }) => {
                const photos = row.original?.photos || [];
                const videos = row.original?.videos || [];

                return (
                    <div className="w-[150px] flex flex-col gap-3">
                        {/* Photos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Photos
                            </p>

                            {photos.length > 0 ? (
                                <>
                                    <img
                                        src={`${process.env.REACT_APP_S3_URL}${photos[0]}`}
                                        alt="Preview"
                                        className="h-20 w-full rounded object-cover border"
                                    />

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewImg(photos);
                                            setPreviewModalOpen(true);
                                        }}
                                    >
                                        View More ({photos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Photos
                                </p>
                            )}
                        </div>

                        {/* Videos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Videos
                            </p>

                            {videos.length > 0 ? (
                                <>
                                    <div className="text-sm text-slate-700 truncate">
                                        🎥 Video 1
                                    </div>

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewVideos(videos);
                                            setPreviewVideoModalOpen(true);
                                        }}
                                    >
                                        View More ({videos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Videos
                                </p>
                            )}
                        </div>
                    </div>
                );
            },
        },
    ];
    const canceledCol = [
        {
            Header: 'SRNO',
            Cell: (prop) => {
                const { data, row } = prop;
                return <div className='font-semibold'>
                    {row.index + complaint?.pagingCounter}
                </div>;
            },
        },
        ...commonColumns,
        {
            Header: 'Cancellation',
            Cell: ({ row }) => {
                return (
                    <div className="max-w-[300px] w-[300px] text-wrap">
                        {row?.original?.cancellationNotes}
                    </div>
                );
            },
        },
        {
            Header: 'Cancel Date',
            Cell: ({ row }) => {
                return (
                    <div>
                        {row.original.cancelDate
                            ? moment
                                .tz(row?.original?.cancelDate, 'Asia/Kolkata')
                                .format('DD-MM-YYYY')
                            : ''}
                    </div>
                );
            },
        },
        {
            Header: 'Photo / Video',
            Cell: ({ row }) => {
                const photos = row.original?.photos || [];
                const videos = row.original?.videos || [];

                return (
                    <div className="w-[150px] flex flex-col gap-3">
                        {/* Photos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Photos
                            </p>

                            {photos.length > 0 ? (
                                <>
                                    <img
                                        src={`${process.env.REACT_APP_S3_URL}${photos[0]}`}
                                        alt="Preview"
                                        className="h-20 w-full rounded object-cover border"
                                    />

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewImg(photos);
                                            setPreviewModalOpen(true);
                                        }}
                                    >
                                        View More ({photos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Photos
                                </p>
                            )}
                        </div>

                        {/* Videos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Videos
                            </p>

                            {videos.length > 0 ? (
                                <>
                                    <div className="text-sm text-slate-700 truncate">
                                        🎥 Video 1
                                    </div>

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewVideos(videos);
                                            setPreviewVideoModalOpen(true);
                                        }}
                                    >
                                        View More ({videos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Videos
                                </p>
                            )}
                        </div>
                    </div>
                );
            },
        },
    ];

    const complaintMemoData = useMemo(() => complaint?.docs ?? [], [complaint]);
    const debouncedSearch = useCallback(
        _.debounce((search) => {
            dispatch(
                fetchComplaints({
                    populate: true,
                    page,
                    search,
                    status: selectedTab,
                })
            );
        }, 300),
        [complaint?.docs]
    );
    const handelTabChange = (tab) => {
        navigate(`/complaint/view-complaint/${tab.value}`);
    };
    const fetchUsers = async () => {
        try {
            const resp = await authAxiosInstance.get(`/users/employee?${QueryString.stringify({ limit: 500 })}`);
            if (resp?.data?.data?.docs?.length > 0) {
                setEmployees(resp?.data?.data?.docs)
            } else {
                setEmployees([])
            }
        } catch (error) {
            console.log("error", error)
        }
    }
    useEffect(() => {
        fetchUsers();
    }, [])
    const columnMap = {
        open: openCol,
        InProgress: InProgressCol,
        pending: pendingCol,
        timeIn: timeInCol,
        observation: observationCol,
        closed: closedCol,
        canceled: canceledCol,
    };
    useEffect(() => {
        console.log("companyDispatchLocation", companyDispatchLocation)
        if (companyDispatchLocation) {
            dispatch(fetchEmployees({ role: { $in: ['executive', 'engineer', 'sales'] }, location: companyDispatchLocation, limit: 500 }));
        }
    }, [companyDispatchLocation])

    return (
        <div className='p-4'>
            <div className="mb-3">
                <ShowDropdown
                    heading={'Reporting'}
                    allowedRoles={[
                        'admin',
                        'executive',
                        'sup_admin',
                        'local_admin',
                        'sales'
                    ]}
                >
                    <form
                        onSubmit={formik.handleSubmit}
                        className="flex flex-col gap-4 mb-4"
                    >
                        <div className="flex gap-5">
                            <FormikInputDateGroup
                                formik={formik}
                                name={'from'}
                                label="From"
                                required
                            />
                            <FormikInputDateGroup
                                formik={formik}
                                name="to"
                                label="To"
                                required
                            />
                        </div>
                        <div>
                            {isLoading ? (
                                <ClipLoader />
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    disabled={formik.isSubmitting}
                                >
                                    Submit
                                </PrimaryButton>
                            )}
                        </div>
                    </form>
                </ShowDropdown>
            </div>
            <UnderlineTabs
                tabs={tabHeaders}
                activeValue={selectedTab}
                onChange={handelTabChange}
            />

            <DocumentPreview
                previewModalOpen={previewModalOpen}
                setPreviewModalOpen={setPreviewModalOpen}
                previewImg={previewImg}
            />
            <VideoPreview
                previewModalOpen={previewVideoModalOpen}
                setPreviewModalOpen={setPreviewVideoModalOpen}
                previewVideos={previewVideos}
            />
            <CloseComplaintModal
                isCloseComplaintBtnOpen={isCloseComplaintBtnOpen}
                setIsCloseComplaintBtnOpen={setIsCloseComplaintBtnOpen}
                closeComplaintData={closeComplaintData}
                page={page}
                status={selectedTab}
            />
            <AssignTechnicianModal
                isAssignTechnicianBtnOpen={isAssignTechnicianBtnOpen}
                setIsAssignTechnicianBtnOpen={setIsAssignTechnicianBtnOpen}
                assignTechnicianData={assignTechnicianData}
                page={page}
                status={selectedTab}

            />
            <ObservationModal
                openObservationModal={openObservationModal}
                setOpenObservationModal={setOpenObservationModal}
                complaintData={closeComplaintData}
                page={page}
                status={selectedTab}
            />
            <CancelModal
                openCancelModal={openCancelModal}
                setOpenCancelModal={setOpenCancelModal}
                complaintData={closeComplaintData}
                page={page}
                status={selectedTab}
            />
            <PendingModal
                openPendingModal={openPendingModal}
                setOpenPendingModal={setOpenPendingModal}
                complaintData={pendingComplaintData}
                page={page}
                status={selectedTab}
            />
            <TimeInModal
                openTimeInModal={openTimeInModal}
                setOpenTimeInModal={setOpenTimeInModal}
                complaintData={timeInComplaintData}
                page={page}
                status={selectedTab}
            />
            <ChangeAssignedTechnicianModal
                isChangeAssignedModalOpen={isChangeAssignedModalOpen}
                setIsChangeAssignedModalOpen={setIsChangeAssignedModalOpen}
                complaintId={changeAssignedComplaintId}
            />
            <EditComoplaintResolutionModal
                editComoplaintResolutionModalOpen={editComoplaintResolutionModalOpen}
                setEditComoplaintResolutionModalOpen={setEditComoplaintResolutionModalOpen}
                complaintId={selectedComplaint?._id}
                reFetchData={() => {
                    dispatch(
                        fetchComplaints({
                            populate: true,
                            page,
                            status: selectedTab,
                        })
                    );
                }}
            />
            <TableWithHeadingAndGlobalSearch
                heading={`View Complaints`}
                // tableClass="max-h-[350px] overflow-x-auto"
                loading={loading}
                columns={columnMap[selectedTab] || []}
                data={complaintMemoData}
                searchFunction={(value) => {
                    debouncedSearch(value);
                }}
            />

            <PaginationClassic
                paginationDetails={{
                    ...complaint,
                    docs: complaint.docs,
                }}
                setPage={setPage}
            />
        </div>
    );
};

export default ViewComplaint;
